import { ComponentProps, forwardRef } from 'react';
import { FormField, FieldBaseProps } from '../FormField';
import { Label } from '../Label';
import { Input as InputField } from 'jbc-front/components/presenters/form/Input';
import { Required } from 'jbc-front/components/presenters/form/Label';
import { ErrorMessage } from 'jbc-front/components/presenters/form/ErrorMessage';
import { Note } from 'jbc-front/components/presenters/ui/Note';
import { ReadMoreReadLess } from 'jbc-front/components/presenters/ui/ReadMoreReadLess';
import { Hint } from 'jbc-front/components/presenters/ui/Hint';

type InputProps = ComponentProps<typeof InputField> &
  FieldBaseProps & {
    noteMaxLength?: number;
  };

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, required = false, hint, note, noteMaxLength, error = undefined, ...inputProps }, ref) => {
    return (
      <FormField>
        {label && (
          <FormField.LabelContainer>
            <Label>
              {label}
              {required && <Required />}
              {hint && <Hint>{hint}</Hint>}
            </Label>
          </FormField.LabelContainer>
        )}

        <InputField {...inputProps} ref={ref} />

        {note && (
          <FormField.NoteContainer>
            <Note>
              {noteMaxLength === undefined ? (
                note
              ) : (
                <ReadMoreReadLess maxLength={noteMaxLength}>{note}</ReadMoreReadLess>
              )}
            </Note>
          </FormField.NoteContainer>
        )}

        {error && (
          <FormField.ErrorContainer>
            <ErrorMessage>{error}</ErrorMessage>
          </FormField.ErrorContainer>
        )}
      </FormField>
    );
  },
);
